import React from 'react'
import { Card  } from 'react-toolbox/lib/card'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import FulcrumDivider from 'components/fulcrum/divider/Divider'
import {
  compose,
} from 'recompose'

import styles from './styles.scss'

const Header = ({title}) => (
  <Flex align='center'>
    <h5 className={styles.headerTitle}>{title}</h5>
  </Flex>
)

const FilterCard = ({title, content}) => (
  <Card theme={styles}>
    <div styleName='header'>
      <Header title={title} />
    </div>
    <FulcrumDivider styleName='divider'/>
    <div styleName='body'>
      {content}
    </div>
  </Card>
)

const withStyles = CSSModules(styles)

export default compose(withStyles)(FilterCard) 